import React, { useContext } from 'react'
import {
    DataLayerEventName,
    EmbedEvent,
    ConfigurationContext,
    UnloadedElectionDefinition,
} from '@news-mono/web-common'
import { TheSeatEmbedWidget } from '../../../widgets'
import {
    ElectorateEmbedData,
    getElectorateData,
    getUnloadedElectionDefinition,
    isStateElection,
} from '../helpers/elections'
import { useImpressionAvailable } from '../../../__helpers/impression-available-helper'

export interface ElectionEmbedProps {
    link: string
    onEvent: (event: EmbedEvent) => void
}
export const ElectionElectorateEmbed: React.FC<ElectionEmbedProps> = ({
    link,
    onEvent,
}) => {
    const isState = isStateElection(link)
    let electorateData: ElectorateEmbedData | undefined
    let unloadedData: UnloadedElectionDefinition | undefined

    const config = useContext(ConfigurationContext)
    const { imageBaseUrl } = config

    try {
        electorateData = getElectorateData(link)
        unloadedData = getUnloadedElectionDefinition(electorateData)
    } catch (error) {
        electorateData = undefined
    }

    // One central location for event building
    const buildEvent = React.useCallback(
        (type: DataLayerEventName) => {
            return {
                type: type,
                originator: 'election-embed',
                payload: {
                    url: window.location.href,
                    embedUrl: link,
                    embedType: electorateData?.type,
                    target: electorateData?.electorate,
                },
            } as EmbedEvent
        },
        [electorateData, link],
    )
    // One central location to fire the event
    const fireEvent = React.useCallback(
        (event: DataLayerEventName) => {
            onEvent(buildEvent(event))
        },
        [onEvent, buildEvent],
    )

    const impressionAvailableRef = useImpressionAvailable({
        loading: false,
        available: () => fireEvent(DataLayerEventName.embedViewed),
    })

    // Only fire events if the electorateData is found properly
    return unloadedData ? (
        <TheSeatEmbedWidget
            isState={isState}
            electorateName={
                electorateData ? electorateData.electorate : 'UNKNOWN'
            }
            electionDefinition={unloadedData}
            mainRef={electorateData ? impressionAvailableRef : undefined}
            fireClickEvent={() => {
                if (electorateData) {
                    fireEvent(DataLayerEventName.embedClicked)
                }
            }}
            imageBaseUrl={imageBaseUrl}
        />
    ) : null
}
